export const checkEmancipationStatus = (logginFailed, componentInstance) => {
  if (logginFailed.error_description === 'awaiting_emancipated') {
    componentInstance.setState({
      emancipationStatusInvalid: {
        open: true,
        severity: 'success',
        text: 'Seu cadastro está em análise. Em breve, você receberá um e-mail com os próximos passos. Fique de olho na sua caixa de entrada!',
      },
    });
    return true;
  }

  if (logginFailed.error_description === 'rejected_emancipated') {
    componentInstance.setState({
      emancipationStatusInvalid: {
        open: true,
        severity: 'success',
        text: 'Seu cadastro foi rejeitado. A imagem do documento não está legível. Por favor, volte ao cadastro e envie uma nova imagem do seu documento.',
      },
    });
    return true;
  }

  return null;
};
